/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const listReviewerPerformanceRecentV2QuerySchema = z.object({
  userId: z.string().min(1),
  limit: z.coerce.number().int().min(1).max(200).default(25),
  offset: z.coerce.number().int().min(0).default(0),
});

export type IListReviewerPerformanceRecentV2Query = z.input<
  typeof listReviewerPerformanceRecentV2QuerySchema
>;
